import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { setPageTitle } from "@/components/app-shell/app-shell";
import { ControlMonitor } from "@/components/control-monitor/control-monitor";
import { authorizeFeatures } from "@/lib/authorize-feature";
import { topLevelFiltersSchema } from "@/lib/filter";

const controlMonitorSchema = z.object({
  active_id: z.string().optional(),
  threat_id: z.string().optional(),
  technique: z.string().optional(),
  filters: topLevelFiltersSchema.optional(),
});

export const Route = createFileRoute("/_app/control-monitor")({
  beforeLoad: () => setPageTitle("Control Monitor"),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    await authorizeFeatures(context, ["policy_evaluator"]);
    if (!Object.hasOwn(deps, "active_id")) {
      throw redirect({
        to: "/control-monitor",
        search: (prev) => ({ ...prev, active_id: "my-controls" }),
        params: (prev) => prev,
      });
    }
  },
  component: ControlMonitorPage,
  pendingComponent: ControlMonitorPage,
  validateSearch: controlMonitorSchema,
});

function ControlMonitorPage() {
  return <ControlMonitor className="flex-1" />;
}
